"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_test_management = __toESM(require("@hcengineering/test-management"));
var import_platform = require("@hcengineering/platform");
const icons = require("../assets/icons.svg");
(0, import_platform.loadMetadata)(import_test_management.default.icon, {
  TestCase: `${icons}#testCase`,
  TestManagementApplication: `${icons}#testManagementApplication`,
  TestManagement: `${icons}#testCase`,
  TestManagementVersion: `${icons}#testCase`,
  TestCases: `${icons}#testCase`,
  Home: `${icons}#home`,
  Estimation: `${icons}#testCase`,
  TestSuite: `${icons}#testSuite`,
  TestProject: `${icons}#project`,
  TestSuites: `${icons}#testSuite`,
  TestRuns: `${icons}#testRun`,
  RedCircle: `${icons}#red-circle`,
  Document: `${icons}#document`,
  StatusDraft: `${icons}#status-draft`,
  StatusReview: `${icons}#status-review`,
  StatusReviewComments: `${icons}#status-review-comments`,
  StatusApproved: `${icons}#status-approved`,
  StatusRejected: `${icons}#status-canceled`,
  TestLibrary: `${icons}#test-library`,
  TestResult: `${icons}#testResult`,
  StatusNonTested: `${icons}#status-untested`,
  StatusBlocked: `${icons}#status-blocked`,
  StatusPassed: `${icons}#status-passed`,
  StatusFailed: `${icons}#status-failed`,
  Run: `${icons}#run`,
  TestPlans: `${icons}#testPlan`
});
//# sourceMappingURL=index.js.map
